import React from 'react';
import Page from './page';

export default function Error404(props) {
  return (
    <Page />
  );
}